import React from 'react';
import {Props} from './model';
import {View} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {Markdown} from '../../../../shared/components/markdown';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';

export default ({content}: Props) => {
  const styles = useStyles(() => ({
    container: {
      flexDirection: 'row',
      marginLeft: -10,
      marginRight: -10,
    },
    item: {
      flex: 1,
      marginLeft: 10,
      marginRight: 10,
    },
  }));
  const deviceSize = useDeviceSize();

  return (
    <View style={styles.container}>
      <View style={styles.item}>
        <Markdown listColumns={deviceSize === DeviceSize.desktop ? 2 : 1}>
          {content.services.transportService.nonFinancial.eCardFeaturesMarkDown}
        </Markdown>
      </View>
    </View>
  );
};
